// extracted by mini-css-extract-plugin
export var productCardStyle = "product-card-module--productCardStyle--db796";
export var productDetailsStyle = "product-card-module--productDetailsStyle--d8de7";
export var productHeadingStyle = "product-card-module--productHeadingStyle--647db";
export var productImageStyle = "product-card-module--productImageStyle--13ac1";
export var productPrice = "product-card-module--productPrice--1d151";
export var productVendorStyle = "product-card-module--productVendorStyle--75bb6";